import { getCurrentUser, signOut } from 'aws-amplify/auth'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router'
import { getUserState, useSelector } from '../store'
import { signOutUser } from '../utils'

export default function RequiresAuth({ children }: { children: any }) {
  const navigate = useNavigate()
  const location = useLocation()

  const [userChecked, setUserChecked] = useState(false)
  const { user } = useSelector(getUserState)

  useEffect(() => {
    const checkUser = async () => {
      try {
        const usr = await getCurrentUser()
        if (!usr || !user?.user_cognito_id) {
          await signOut()
          signOutUser()
          navigate('/login')
        }
      } catch (error) {
        await signOut()
        signOutUser()
        navigate('/login', { state: { from: location.pathname } })
      }
      setUserChecked(true)
    }
    checkUser()
  }, [Boolean(user?.user_cognito_id), location, navigate])

  if (userChecked) {
    return children
  }
}
